import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { PoolSelect, useFilter } from '@synergy/components';
import { ReactNode } from 'react';

import { useAppSelector } from '../../../store/use-appstate-selector';

export interface ResponsibleQuickContactFilterProps {
    allText?: ReactNode;
    ownText?: ReactNode;
}

export const ResponsibleQuickContactFilter = (props: ResponsibleQuickContactFilterProps) => {
    const { filter, updateFilter, registerFilterMap } = useFilter();
    const { contact: userContact } = useAppSelector(state => state.user);
    const { flat: contacts } = useAppSelector(state => state.contacts);

    const onSelected = (responsibleContactId: number) => {
        filter.delete(FilterParams.ResponsibleContactId);
        if (responsibleContactId) {
            filter.set(FilterParams.ResponsibleContactId, responsibleContactId.toString());
        }
        updateFilter(filter);
    };

    registerFilterMap(FilterParams.ResponsibleContactId, (id: unknown) => {
        const contactId = Number(id);
        if (!contactId) {
            return '';
        }

        if (contactId === userContact.id) {
            return userContact.fullName;
        }

        const foundContact = contacts.find(contact => contact.id === contactId);
        return foundContact?.fullName;
    });

    const filterOptions = [
        {
            value: 'undefined',
            displayValue: props.allText ?? <FormattedMessage id="app.filter.showAll" />,
        },
        {
            value: userContact.id,
            displayValue: props.ownText ?? <FormattedMessage id="app.filter.showOwn" />,
        },
    ];

    return (
        <PoolSelect
            options={filterOptions}
            styleType="simple"
            disallowDefaultValue={true}
            // "All" is the option whose value is the string 'undefined': without
            // it the select stood empty, and "own" was only found for the
            // contact with the id 1.
            value={
                filter.get(FilterParams.ResponsibleContactId) === String(userContact.id) ? userContact.id : 'undefined'
            }
            onValueChange={onSelected}
            variant="standard"
        />
    );
};
